import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { SHARED_RECIPE_PATH } from '../shared/sharing';
import { useIsAdmin } from './api/hooks';
import { AboutPage } from './pages/AboutPage';
import { AdminPage } from './pages/AdminPage';
import { CoachPage } from './pages/CoachPage';
import { ProgressPage } from './pages/ProgressPage';
import { RecipePage } from './pages/RecipePage';
import { RecipesPage } from './pages/RecipesPage';
import { SharedRecipePage } from './pages/SharedRecipePage';
import { TodayPage } from './pages/TodayPage';
import { YouPage } from './pages/YouPage';

/** Signed-in pages. `/` stays Today; About is available here too. */
export function appRouteElements(): { path: string; element: ReactElement }[] {
  return [
    { path: '/', element: <TodayPage /> },
    { path: '/progress', element: <ProgressPage /> },
    { path: '/recipes', element: <RecipesPage /> },
    { path: '/recipes/:id', element: <RecipePage /> },
    { path: SHARED_RECIPE_PATH, element: <SharedRecipePage /> },
    { path: '/coach', element: <CoachPage /> },
    { path: '/you', element: <YouPage /> },
    { path: '/about', element: <AboutPage /> },
  ];
}

export function AppRoutes() {
  const isAdmin = useIsAdmin();
  return (
    <Routes>
      {appRouteElements().map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
      <Route path="/admin" element={isAdmin ? <AdminPage /> : <Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
